import React, { Fragment, useEffect, useRef } from 'react';
import { UrlEnum } from '../../../shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import format from 'date-fns/format';

export const RequestNav = ({
    requestNavData,
    currentRequestId,
    setCurrentRequestId,
}) => {
    const activeRef = useRef(null);
    useEffect(() => {
        if (activeRef.current) {
            activeRef.current.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }
    }, [currentRequestId, requestNavData]);

    const reqStatus = requestNavData?.length > 0 ? requestNavData[0].status : null;
    const formatCreatedDate = createdDate => {
        const date = new Date(createdDate);
        return <Fragment>{format(date, 'M/d/yyyy')}</Fragment>;
    };
    return (
        <nav className="requests-nav">
            <div className="fullpage-header d-md-flex align-items-center justify-content-between">
                <a href={UrlEnum.ADMIN_SEARCH_ACADEMIC_PROGRAM_REQUESTS}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back to all program requests
                </a>
            </div>
            <div className="fullpage-header d-md-flex align-items-center justify-content-between">
                <h5 className="mb-0 mx-auto text-600 ">{reqStatus} Program Requests</h5>
            </div>
            <div className="p-3">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="search..."
                        aria-label="search..."
                    />
                    <div className="input-group-append">
                        <button className="btn btn-white" type="button">
                            <i className="far">
                                <FontAwesomeIcon icon={faSearch} />
                            </i>
                        </button>
                    </div>
                </div>
            </div>
            <ul className="list-group list-group-flush requests-nav-list">
                {requestNavData?.map((navCard, index) => (
                    <li
                        key={index}
                        ref={navCard.requestID === currentRequestId ? activeRef : null}
                    >
                        <a
                            role="button"
                            className={`list-group-item ${
                                navCard.requestID === currentRequestId ? 'active' : ''
                            }`}
                            onClick={() => {
                                setCurrentRequestId(navCard.requestID);
                            }}
                        >
                            <div className="d-xl-flex align-items-center mb-2">
                                <p className="mb-0 mr-3">
                                    <i className="far fa-calendar"></i>{' '}
                                    {formatCreatedDate(navCard.createdOn)}
                                </p>
                                <p className="mb-0">{navCard.institutionName}</p>
                            </div>
                            <p className="text-italic mb-0">{navCard.programName}</p>
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
